<div class="content layout vertical center middle" style="width: 100%; text-align: center;">
    <h1>Utente disabilitato per ragioni di sicurezza.</h1>
    <p>Contattare il call center di supporto al numero 011.7541142 o via email all’indirizzo nuovoimaie@feedbackitalia.it.</p>
</div>